import React from 'react'
import Translation from '../../Translation/cont/Translation'


const FlyerSmallPagePreviewItem = ({section, transId, side, flyerStructureData}) => {
    let tooHigh = false

    if(flyerStructureData && flyerStructureData[side][section]) {
        if(flyerStructureData[side][section].hasOwnProperty('tooHigh')) {
            tooHigh = flyerStructureData[side][section].tooHigh
        } else {
            tooHigh = true
        }
    }

    return (
        <div className={'preview-wrapper-' + section}>
            <div className={'section-wrapper-' + section}>
                <p><Translation id={transId}/></p>
                {tooHigh && <div className="too-high-wrapper">
                    <div className="no-content-alert">
                        <span className="print-title-xlarge">!</span>
                    </div>
                </div>}
            </div>
        </div>
    )
}

const FlyerSmallPagePreview = ({outside, sectionActive, side, flyerStructureData}) => {
    return <div className={'outer-preview-wrapper ' + sectionActive}>
        <FlyerSmallPagePreviewItem 
            section='left'
            transId={outside ? 'print_flyer_page_1' : 'print_flyer_inside_left'}
            side={side}
            flyerStructureData={flyerStructureData}
        />
        <FlyerSmallPagePreviewItem 
            section='middle'
            transId={outside ? 'print_flyer_back_u4' : 'print_flyer_inside_middle'}
            side={side}
            flyerStructureData={flyerStructureData}
        />
        <FlyerSmallPagePreviewItem 
            section='right'
            transId={outside ? 'print_flyer_title_u1' : 'print_flyer_inside_right'}
            side={side}
            flyerStructureData={flyerStructureData}
        />
    </div>
}

export default FlyerSmallPagePreview